const isValid = (value) => typeof value !== 'undefined' && value !== null;

export const formToNumber = (value) => (value === '' ? null : value);

export const valueToForm = (value) => (isValid(value) ? value : '');
export const arrayToForm = (value) => (isValid(value) ? value : []);
export const boolToForm = (value) => (isValid(value) ? value : false);
